import getHeight from "../../../particles/getHeight";

const app = {
  init: () => {
    app.phones()
    app.toggleInfo()
  },
  toggleInfo: () => {
    let items = document.querySelectorAll('.info .info__item-link')
    items.forEach((item) => {
      item.addEventListener('click', () => {
        let content = item.parentNode.querySelector('.info__item-content')
        let contentHeight = getHeight(content.querySelector('.item__content'))

        if (item.parentNode.classList.contains('js_active')) {
          item.parentNode.classList.toggle('js_active')
          content.style.height = contentHeight + 'px'
          setTimeout(() => {
            content.style.height = '0'
          }, 1)
        } else {
          let otherItems = item.closest('.info').querySelector('.info__item.js_active')
          if (otherItems) {
            otherItems.classList.toggle('js_active')
            otherItems.querySelector('.info__item-content').style.height = ''
          }
          item.parentNode.classList.toggle('js_active')
          content.style.height = contentHeight + 'px'
          setTimeout(() => {
            content.style.height = 'auto'
          }, 300)
        }
      })
    })

    let subItems = document.querySelectorAll('.info .item__submenu-link')
    subItems.forEach((item) => {
      item.addEventListener('click', () => {
        let content = item.parentNode.querySelector('.item__submenu-content')
        let contentHeight = getHeight(content.querySelector('.item__content'))

        if (item.parentNode.classList.contains('js_active')) {
          item.parentNode.classList.toggle('js_active')
          content.style.height = contentHeight + 'px'
          setTimeout(() => {
            content.style.height = '0'
          }, 1)
        } else {
          let otherItems = item.closest('.item__submenu').querySelector('.js_active')
          if (otherItems) {
            otherItems.classList.toggle('js_active')
            otherItems.querySelector('.item__submenu-content').style.height = ''
          }
          item.parentNode.classList.toggle('js_active')
          content.style.height = contentHeight + 'px'
          setTimeout(() => {
            content.style.height = 'auto'
          }, 300)
        }
      })
    })
  },
  phones: () => {
    const phones = document.querySelector('.contacts__phones')
    const contactsInfo = document.querySelector('.contacts__info')
    const contactsAddressHolder = document.querySelector('.contacts__address-holder')
    if (window.innerWidth >= 576 && window.innerWidth < 992 && phones != null) {
      contactsAddressHolder.appendChild(phones)
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 576 && window.innerWidth < 992 && phones != null) {
        contactsAddressHolder.appendChild(phones)
      } else {
        if (phones != null) {
          contactsInfo.insertBefore(phones, contactsInfo.children[0])
        }
      }
    })
  },
}

export default app
